module.exports = __webpack_public_path__ + "img/TheSwordandtheGrailExcalibur.d8a38d4d.png";